import { render, staticRenderFns } from "./simple-project-site-card.vue?vue&type=template&id=5a41f06a&scoped=true"
import script from "./simple-project-site-card.vue?vue&type=script&lang=js"
export * from "./simple-project-site-card.vue?vue&type=script&lang=js"
import style0 from "./simple-project-site-card.vue?vue&type=style&index=0&id=5a41f06a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a41f06a",
  null
  
)

export default component.exports